import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('radial-bar-chart',{staticClass:"fill-height",attrs:{"series":[ _vm.getStatValue('UXMAXVELREF') || 0 ],"plot-options":{
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: _vm.getStatValue('CACGCSMXV') ? -2 : 25,
            fontSize: '24px'
          },
          total: {
            show: true,
            label: _vm.getStatValue('CACGCSMXV'),
            formatter: function () { return _vm.getStatValue('CACGCSMXV') ? _vm.getStatValue('CACGCSMXV') : 'N/A'; }
          }
        }
      }
    },"tooltip":{
      enabled: true,
      y: {
        formatter: function () { return ((_vm.getStatValue('UXMAXVELREF')) + "%"); },
        title: {
          formatter: function () { return _vm.getVariableName('UXMAXVELREF') + ':'; }
        }
      }
    },"animations":{enabled: false}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c(VCardTitle,{staticClass:"pa-4"},[_c(VRow,{attrs:{"no-gutters":"","align":"center"}},[_c(VCol,[_c('div',{staticClass:"subtitle-2 grey--text text--grey-100",staticStyle:{"word-break":"normal"}},[_vm._v(" "+_vm._s(_vm.$t('card_title.velocity'))+" ("+_vm._s(_vm.getVariableSuffix('CACGCSMXV'))+")"+_vm._s(_vm.aggregation ? ": " + _vm.$t(("variables." + _vm.aggregation + ".long")) : '')+" ")])]),_c(VCol,{staticClass:"ml-3 ",attrs:{"cols":"auto"}},[(_vm.removable)?_c(VBtn,{staticStyle:{"pointer-events":"auto"},attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('remove')}}},[_c(VIcon,{attrs:{"small":""}},[_vm._v(" fal fa-times ")])],1):_vm._e()],1)],1)],1)]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"d-flex justify-center"},[_c('span',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.getVariableName('UXAVGVEL'))+": "+_vm._s(_vm.getStatValue('UXAVGVEL'))+_vm._s(_vm.getVariableSuffix('UXAVGVEL')))])])]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }